export default "__VITE_ASSET__BXbnWLUF__"